import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  FormControl, InputLabel, Select, MenuItem, Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import useQueues from "../../hooks/useQueues";

/**
 * Modal transferencia batch — simplificado vs TransferTicketModal (single).
 * Solo permite elegir cola destino (cada ticket puede tener distinta conexión,
 * por eso whatsappId NO es configurable en batch).
 *
 * Props:
 *  - open, onClose
 *  - count
 *  - onTransfer(queueId)
 */
const BatchTransferDialog = ({ open, onClose, count = 0, onTransfer, loading = false }) => {
  const { findAll: findAllQueues } = useQueues();
  const [queues, setQueues] = useState([]);
  const [queueId, setQueueId] = useState("");

  useEffect(() => {
    if (!open) return;
    setQueueId("");
    findAllQueues().then(list => {
      // feat_184: ofrecer TODAS las colas de la company a cualquier perfil
      // (paridad con TransferTicketModal/single). El scope per-ticket del
      // backend decide QUÉ tickets se mueven; el destino solo exige cola de
      // la company. Antes el non-admin quedaba limitado a sus colas propias.
      setQueues(list || []);
    }).catch(() => setQueues([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const canSubmit = !!queueId && !loading;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("batchTransferDialog.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
          {i18n.t("batchTransferDialog.subtitle", { count })}
        </Typography>
        <FormControl variant="outlined" fullWidth size="small">
          <InputLabel>{i18n.t("batchTransferDialog.queueLabel")}</InputLabel>
          <Select
            value={queueId}
            onChange={e => setQueueId(e.target.value)}
            label={i18n.t("batchTransferDialog.queueLabel")}
          >
            <MenuItem value="">
              <em>{i18n.t("batchTransferDialog.queuePlaceholder")}</em>
            </MenuItem>
            {queues.map(q => (
              <MenuItem key={q.id} value={q.id}>{q.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {i18n.t("batchTransferDialog.cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!canSubmit}
          onClick={() => onTransfer(Number(queueId))}
        >
          {i18n.t("batchTransferDialog.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BatchTransferDialog;
